import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import remove from 'lodash/remove';

import { SystemUi } from '../System/systemUi';
import { UiFollowPoint } from './uiFollowPoint';

export interface HoverPoint {
    point: Vector3,
    text: string,
}

export class UiHoverPoints {
    protected system: SystemUi;

    protected container: HTMLElement;

    constructor(
        system: SystemUi,
        container: HTMLElement,
        hoverPoints: HoverPoint[],
    ) {
        this.system = system;
        this.container = container;
        hoverPoints.forEach((hoverPoint) => {
            this.addPoint(hoverPoint);
        });

        //* For test purpose
        // this.addPoint({ point: Vector3.Zero(), text: 'Hand made leather' });
    }

    private followPoints: UiFollowPoint[] = [];

    public addPoint(hoverPoint: HoverPoint): void {
        const uiFollowPoint = new UiFollowPoint(this.system, this.container);
        uiFollowPoint.show();
        uiFollowPoint.keepPointVisible = true;
        uiFollowPoint.followPoint(hoverPoint.point, hoverPoint.text);
        this.followPoints.push(uiFollowPoint);
        uiFollowPoint.point.addEventListener('mouseenter', () => {
            uiFollowPoint.showAnim();
        });
        uiFollowPoint.point.addEventListener('mouseleave', () => {
            uiFollowPoint.shown = false;
            setTimeout(() => {
                //* In case point is hovered again and shown
                if (!uiFollowPoint.shown) uiFollowPoint.hideAnim();
            }, 1000);
        });
    }

    public removePoint(point: Vector3): void {
        const removedPoint = remove(this.followPoints, (fP) => fP.point === point);
        console.log(removedPoint);
        if (removedPoint) removedPoint.delete();
    }
}
